// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"teamMemberList_accessRightIndicator__2TXXE"};